// extracted by mini-css-extract-plugin
export default {"bgImage":"bhoFCw","loader":"rRaFI2"};